// extracted by mini-css-extract-plugin
export default {"box":"LoginForm_box__QELk4"};